//components
import { BasicButton} from 'thrive-components';

//interfaces
import { IRecoveryRequestPanel } from  '@/interfaces/passkeys';



const RecoveryRequestPanel = ({onViewRequestsClick} : IRecoveryRequestPanel) => {  

    return(
        <div className='recovery-request-panel thrive-red-info-panel'>
            Someone who claims to be this user and has requested a recovery code. Only proceed if you've confirmed it's really them.

            <div className='recovery-request-button-panel'>
                <BasicButton 
                    content={"View Requests"} 
                    ariaLabel={'View Requests'} 
                    onButtonClick={onViewRequestsClick}
                />
            </div>
        </div>
    )
}

export default RecoveryRequestPanel